export default "__VITE_ASSET__DP6wQdtJ__"